interface SensitivityResultsItemInterface {
 'SENSITIVITY.RESULTS.VARIABLE_HEADER'?: string;
 'SENSITIVITY.RESULTS.BASELINE_VALUE_HEADER'?: string;
 'SENSITIVITY.RESULTS.MINIMUM_CHANGE_HEADER'?: string;
 'SENSITIVITY.RESULTS.MINIMUM_VALUE_HEADER'?: string;
 'SENSITIVITY.RESULTS.MAXIMUM_CHANGE_HEADER'?: string;
 'SENSITIVITY.RESULTS.MAXIMUM_VALUE_HEADER'?: string;
}

export class SensitivityResultsItem {
  'SENSITIVITY.RESULTS.VARIABLE_HEADER';
  'SENSITIVITY.RESULTS.BASELINE_VALUE_HEADER';
  'SENSITIVITY.RESULTS.MINIMUM_CHANGE_HEADER';
  'SENSITIVITY.RESULTS.MINIMUM_VALUE_HEADER';
  'SENSITIVITY.RESULTS.MAXIMUM_CHANGE_HEADER';
  'SENSITIVITY.RESULTS.MAXIMUM_VALUE_HEADER';
  get variableHeader() {
    return this['SENSITIVITY.RESULTS.VARIABLE_HEADER'];
  }
  set variableHeader(value: string) {
    this['SENSITIVITY.RESULTS.VARIABLE_HEADER'] = value;
  }
  get baseline() {
    return this['SENSITIVITY.RESULTS.BASELINE_VALUE_HEADER'];
  }
  set baseline(value: string) {
    this['SENSITIVITY.RESULTS.BASELINE_VALUE_HEADER'] = value;
  }
  get minChange() {
    return this['SENSITIVITY.RESULTS.MINIMUM_CHANGE_HEADER'];
  }
  set minChange(value: string) {
    this['SENSITIVITY.RESULTS.MINIMUM_CHANGE_HEADER'] = value;
  }
  get minValue() {
    return this['SENSITIVITY.RESULTS.MINIMUM_VALUE_HEADER'];
  }
  set minValue(value: string) {
    this['SENSITIVITY.RESULTS.MINIMUM_VALUE_HEADER'] = value;
  }
  get maxChange() {
    return this['SENSITIVITY.RESULTS.MAXIMUM_CHANGE_HEADER'];
  }
  set maxChange(value: string) {
    this['SENSITIVITY.RESULTS.MAXIMUM_CHANGE_HEADER'] = value;
  }
  get maxValue() {
    return this['SENSITIVITY.RESULTS.MAXIMUM_VALUE_HEADER'];
  }
  set maxValue(value: string) {
    this['SENSITIVITY.RESULTS.MAXIMUM_VALUE_HEADER'] = value;
  }


  constructor(param: SensitivityResultsItemInterface = {}) {
    this['SENSITIVITY.RESULTS.VARIABLE_HEADER'] = param['SENSITIVITY.RESULTS.VARIABLE_HEADER'] ?? '';
    this['SENSITIVITY.RESULTS.BASELINE_VALUE_HEADER'] = param['SENSITIVITY.RESULTS.BASELINE_VALUE_HEADER'] ?? '';
    this['SENSITIVITY.RESULTS.MINIMUM_CHANGE_HEADER'] = param['SENSITIVITY.RESULTS.MINIMUM_CHANGE_HEADER'] ?? '';
    this['SENSITIVITY.RESULTS.MINIMUM_VALUE_HEADER'] = param['SENSITIVITY.RESULTS.MINIMUM_VALUE_HEADER'] ?? '';
    this['SENSITIVITY.RESULTS.MAXIMUM_CHANGE_HEADER'] = param['SENSITIVITY.RESULTS.MAXIMUM_CHANGE_HEADER'] ?? '';
    this['SENSITIVITY.RESULTS.MAXIMUM_VALUE_HEADER'] = param['SENSITIVITY.RESULTS.MAXIMUM_VALUE_HEADER'] ?? '';
  }
}